import OrderDTO from "@/dto/order/OrderDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import OrderStatus from "@/enum/OrderStatus";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { Checkbox, Tooltip, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface OrderItemRowCheckboxProps {
    order: OrderDTO;

    orderItem: OrderItemDTO;

    mergerOrder?: OrderDTO;
}

const OrderItemRowCheckbox: React.FC<OrderItemRowCheckboxProps> = function (props) {
    const { order, orderItem, mergerOrder } = props;
    const orderManagementStore = useOrderManagementStore();

    // 这里快速查单也用到，快速查单场景中不支持单独选orderItem
    const locking = orderManagementStore
        ? !!orderManagementStore.table.orderLockStore.lockOrderIdMapping.get(order.id)
        : true;

    let isSelected;

    if (order.mergeSplitStatus === OrderMergeSplitStatus.MERGE_CHILD && mergerOrder) {
        const childOrderItem = mergerOrder.orderItems?.find((it: any) => it.id === orderItem.id);
        // @ts-ignore
        isSelected = childOrderItem?.isSelected === true;
    } else {
        // @ts-ignore
        isSelected = orderItem?.isSelected === true;
    }

    let children = null;

    // 已取消的OrderItem不能被用户选择（Order状态为已取消时除外）
    let selectable = true;

    if (mergerOrder) {
        selectable =
            (orderItem.status !== OrderStatus.CANCELED || mergerOrder.status === OrderStatus.CANCELED) && !locking;
    } else {
        selectable = (orderItem.status !== OrderStatus.CANCELED || order.status === OrderStatus.CANCELED) && !locking;
    }

    if (selectable) {
        children = (
            <Checkbox
                checked={isSelected}
                onChange={(e) => {
                    const checked = e.target.checked;

                    if (checked) {
                        orderManagementStore.table.selectOrderItem(order.id, orderItem.id);
                    } else {
                        orderManagementStore.table.unselectOrderItem(order.id, orderItem.id);
                    }
                }}
            />
        );
    }

    const showTip = order.status !== orderItem.status;

    if (selectable && showTip) {
        children = (
            <Tooltip title="请谨慎选择和订单状态不一致的商品打印">
                <Checkbox
                    checked={isSelected}
                    onChange={(e) => {
                        const checked = e.target.checked;

                        if (checked) {
                            Modal.confirm({
                                title: "确定要选择已发货或已成功的商品打印吗?",
                                content: <span className="text-error">可能会造成重复发货，请谨慎选择</span>,
                                onOk() {
                                    orderManagementStore.table.selectOrderItem(order.id, orderItem.id);
                                },
                                okText: "继续",
                                okButtonProps: {
                                    danger: true,
                                },
                            });
                        } else {
                            orderManagementStore.table.unselectOrderItem(order.id, orderItem.id);
                        }
                    }}
                />
            </Tooltip>
        );
    }

    return children;
};

export default observer(OrderItemRowCheckbox);
